import { Panel } from '../..'
import BotHead from '../Avatar/BotHeadColored'
import { defineMessages, useIntl } from 'react-intl'
import { Heading, Text } from '@homebotapp/hb-react-component-catalog'
import { CustomerProfileData } from '../../../types/customerProfile'
import { HOME_ESTIMATE_EMPTY_STATE } from '../../../constants/document_ids'

import styles from './AvmModuleZeroState.module.scss'

const MSG = defineMessages({
  whatsYourHomeWorth: {
    id: 'Homeowner.estimatedValue.zeroState',
    defaultMessage: "What's your home worth?"
  },
  trouble: {
    id: 'Homeowner.estimatedValue.zeroState.trouble',
    defaultMessage: "We're having a little trouble gathering enough data to calculate an accurate value"
  },
  notified: {
    id: 'Homeowner.estimatedValue.zeroState.notifiedNewKey',
    defaultMessage:
      "Don't worry, {firstName} is on the case! {firstName} has been notified and we'll get to the work on resolving your home details!"
  }
})

interface AvmModuleZeroStateProps {
  customerProfile: CustomerProfileData
}

export const AvmModuleZeroState = ({ customerProfile }: AvmModuleZeroStateProps) => {
  const intl = useIntl()

  return (
    <Panel
      data-qa='EstimatedValueZeroState'
      id={HOME_ESTIMATE_EMPTY_STATE}
      className={styles.container}
      scrollMarginTop='var(--digest-module-scroll-margin-top)'
    >
      <Heading fontWeight='semibold' size='xl' className={styles.heading}>
        {intl.formatMessage(MSG.whatsYourHomeWorth)}
      </Heading>
      <div className={styles.messagingContainer}>
        <div className={styles.peekTop}>
          <BotHead quizzical type='danger' className={styles.peekTopAvatar} />
        </div>
        <Text color='neutral-900' size='md' marginBottom={2}>
          {intl.formatMessage(MSG.trouble)}
        </Text>
        <Text size='sm'>
          {intl.formatMessage(MSG.notified, {
            firstName: customerProfile.firstName
          })}
        </Text>
      </div>
    </Panel>
  )
}
